import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getCourse: (state) => (id) => {
    return state.all.find(course => course.id === id)
  },
  getCourseDetail:(state) => state.courseDetail
}

const actions = {
  fetchAll ({ rootGetters, commit }, areaId) {
    const params = {
      id: 'Chofu',
      areaId: areaId,
      language: rootGetters['user/getLang']
    }
    return new Promise((resolve) => {
      api.getCourses(params)
        .then(courses => {
          commit('setCourses', courses)
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  },
  fetchCourseDetail ({ rootGetters,commit }, courseId) {
    const params = {
      id: 'Chofu',
      courseId: courseId,
      language: rootGetters['user/getLang']
    }
    return new Promise((resolve) => {
      api.getCourseDetail(params)
        .then(courseDetail => {
          commit('setCourseDetail', courseDetail)
          resolve()
        })
    })
  },
}

const mutations = {
  setCourses (state, courses) {
    state.all = courses
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  setCourseDetail (state, courseDetail) {
    state.courseDetail = courseDetail
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
